export default function getPath(code, whiteLabel, language) {
  let path = whiteLabel.pages.find(page => page.code === code).path[language];
  if (whiteLabel.path) {
    path = "/" + whiteLabel.path + path;
  }
  return path;
}
